// extracted by mini-css-extract-plugin
export default {"swatches-dropdown-container":"z8gko75bLNb1sdblu-CSJg=="};